import React, { FC, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { SvgIcons } from './SvgIcons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ListGroup from 'react-bootstrap/ListGroup';
import { Button } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import FilledInput from '@mui/material/FilledInput';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormHelperText from '@mui/material/FormHelperText';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

interface IInputPassword {
    controlId: string;
    label: string;
    placeholder: string;
    handleChange: any;
    handleBlur: any;
    errorsField: any;
    touched: any
    value: any
}

/**
 * Input Type Password Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched
}
 * @returns {*}
 */
const InputPassword: FC<IInputPassword> = ({
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, value
}) => {
    const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setPasswordType((show) => !show);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

    const [passwordType, setPasswordType] = React.useState(false);


    
  

    //const togglePassword = () => {
        
            
       // if (passwordType === "password") {
           // setPasswordType("text")
            //return;
        //}
        //setPasswordType("password")
    //}
 
    return (

        <>

         <TextField
          onBlur={handleBlur}
          id="outlined-disabled"
          label={label}          
          placeholder={placeholder}
          defaultValue={value} 
          onChange={handleChange}          
          type={passwordType ? 'text' : 'password'}
          InputProps={{
            endAdornment: <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {passwordType ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>,
          }}
          error={errorsField && touched}
          helperText={errorsField && touched?errorsField:""}
          name={controlId}
          
        />
         
        </>

        //<Form.Group className="mb-3 pb-1" controlId={controlId}>
           // <Form.Label className="mb-1 text-uppercase fs-11 fw-bold label-color ls-small">{label}
            //    <OverlayTrigger
            //        placement="top"
            //        overlay={renderTooltip}
            //    >
            //        <Button className="align-baseline d-inline-block infoIcon ms-1 p-0" variant="link">{SvgIcons.infoCircleIcon}</Button>
            //    </OverlayTrigger>
            //</Form.Label>
            //<div className="position-relative form-icon-active">
            //    <Form.Control value={value} type={passwordType} placeholder={placeholder} onBlur={handleBlur} onChange={handleChange} isInvalid={!!errorsField && touched} />
            //    <Form.Control.Feedback type="invalid">
            //        {touched ? errorsField : ''}
            //    </Form.Control.Feedback>
            //    <div onClick={togglePassword} className="align-items-center cursor-pointer d-flex end-0 h-40 justify-content-center position-absolute text-center toggleEyeIcons top-0 w-40">
            //        {passwordType === "password" ? <span className="eyeOff">{SvgIcons.eyeOffIcon}</span> : <span className="eyeOn">{SvgIcons.eyeIcon}</span>}
           //     </div>
           // </div>
        //</Form.Group>
    );
}

export default InputPassword